import app from 'flarum/common/app';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Tooltip from 'flarum/common/components/Tooltip';
import Avatar from 'flarum/common/components/Avatar';
import Link from 'flarum/common/components/Link';
import extractText from 'flarum/common/utils/extractText';
import Widget from 'ext:fof/forum-widgets-core/common/components/Widget';
import onlineUsersState from '../onlineUsersState';
export default class OnlineUsersWidget extends Widget {
  className() {
    return 'FoF-OnlineUsersWidget';
  }
  icon() {
    return 'fas fa-user-friends';
  }
  title() {
    return extractText(app.translator.trans('fof-online-users-widget.forum.widget.title'));
  }
  content() {
    // Always the server's answer. Realtime keeps it current by refetching when
    // presence membership changes, rather than substituting its own list — see
    // forum/extendRealtime.ts.
    const users = (app.forum.onlineUsers() || []).filter(u => u !== undefined);
    const total = app.forum.totalOnlineUsers() || 0;

    // Only the very first load has nothing to show; later refetches swap
    // results in underneath the existing list rather than blanking it.
    if (onlineUsersState.isLoading && users.length === 0) {
      return m(LoadingIndicator, null);
    }
    return m("div", {
      className: "FoF-OnlineUsersWidget-users"
    }, m("div", {
      className: "FoF-OnlineUsersWidget-users-message"
    }, users.length === 0 ? app.translator.trans('fof-online-users-widget.forum.widget.empty') : null), m("div", {
      className: "FoF-OnlineUsersWidget-users-list"
    }, users.map(user => m(Link, {
      href: app.route('user', {
        username: user.slug()
      }),
      className: "FoF-OnlineUsersWidget-users-item"
    }, m(Tooltip, {
      text: user.displayName()
    }, m(Avatar, {
      user: user
    })))), total > users.length ? m("span", {
      className: "FoF-OnlineUsersWidget-users-item FoF-OnlineUsersWidget-users-item--plus"
    }, m("span", {
      className: "Avatar"
    }, `+${total - users.length}`)) : null));
  }
}
flarum.reg.add('fof-online-users-widget', 'common/components/OnlineUsersWidget', OnlineUsersWidget);